<section class="demo-evrn-method section">
  <div class="demo-evrn-method__inner">
    <div class="container">
      <h2 class="demo-evrn-method__title title-dark">The EVRN Method</h2>

      <p class="demo-evrn-method__subtitle subheading-dark">
        We are removing the uncertainty from the generative video process. Giving complete control
        and consistency back to the maker.
      </p>
    </div>

    <app-auto-expandable-cards [cards]="steps" />
  </div>
</section>
